import { handleActions, combineActions } from 'redux-actions';
import * as actionTypes from '../actions/actionTypes';

const initialState = {
  records: [],
  totalUnreadMessages: 0,
  pagesQuantity: 1,
  isLoading: false,
  error: null
};

export default handleActions(
  {
    [combineActions(actionTypes.GET_CONVERSATIONS_START, actionTypes.SEND_CONVERSATIONS_START)]: state => ({
      ...state,
      isLoading: true,
      error: null
    }),
    [actionTypes.GET_CONVERSATIONS_SUCCESS]: (state, action) => ({
      ...state,
      records: action.records,
      pagesQuantity: action.pagesQuantity || initialState.pagesQuantity,
      isLoading: false,
      error: null
    }),
    [actionTypes.SEND_CONVERSATIONS_SUCCESS]: (state, action) => ({
      ...state,
      records: action.records,
      isLoading: false,
      error: null
    }),
    [actionTypes.GET_UNREAD_MESSAGES_QUANTITY]: (state, action) => ({
      ...state,
      totalUnreadMessages: action.unread_count,
      isLoading: false,
      error: null
    }),
    [combineActions(actionTypes.GET_CONVERSATIONS_ERROR, actionTypes.SEND_CONVERSATIONS_ERROR)]: (state, action) => ({
      ...state,
      isLoading: false,
      error: action.error
    }),
    [actionTypes.INCREMENT_UNREAD_COUNT]: (state, action) => ({
      ...state,
      totalUnreadMessages: action.totalUnreadMessages
    }),
    [actionTypes.CLEAR_CONVERSATIONS_HISTORY]: () => initialState
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/reducers/conversations.js